module.exports = __webpack_public_path__ + "static/31-11459da5704b370b654dee28a7fb0a2a.jpg";